export const programSections = [
    {
        title: "Программы", // Заголовок верхнего уровня
        type: "category", // Добавим тип для дифференциации
        subItems: [ // Теперь это массив под-элементов/подкатегорий
            {
                title: "ЭКГ – Электрокардиограмма",
                description: "Является одной из самых безопасных и доступных методик. Применяется как при плановых медицинских осмотрах, так и для диагностики патологий и вторичных изменений в сердце при заболеваниях других систем и органов.",
                imageUrl: "/Assets/Programs/1.jpg",
            },
            {
                title: "Грязелечение тамбуканской грязью",
                description: "Грязелечение - древнейший способ оздоровления организма. Известно, что этот способ лечения применялся еще в Древнем Риме и в странах Древнего Востока, о чем ясно свидетельствуют письменные источники, дошедшие до наших времен.",
                imageUrl: "/Assets/Programs/2.jpg",
            },
            {
                title: "Магнитотерапия",
                description: "Является методом альтернативной медицины, при котором используют воздействие магнитного поля на организм человека с целью лечения и профилактики различных заболеваний.",
                imageUrl: "/Assets/Programs/3.jpg",
            },
            {
                title: "Терренкур",
                description: "Терренкур-дозированная лечебная ходьба по пересеченной местности.",
                imageUrl: "/Assets/Programs/4.jpg",
            },
            {
                title: "ЛФК – Лечебная физическая культура",
                description: "Повышение двигательной активности – необходимый элемент санаторно-курортного лечения.",
                imageUrl: "/Assets/Programs/5.jpg",
            },
            {
                title: "Лечебное плавание",
                description: "Лечебное плавание – это вид лечебной физкультуры. Его преимущество заключается в том, что на организм одновременно воздействуют вода и активные движения. Физические упражнения в воде стимулируют работу сердца, дыхания, желудочно-кишечного тракта.",
                imageUrl: "/Assets/Programs/6.jpg",
            },
            {
                title: "Скандинавская ходьба",
                description: "Скандинавская ходьба — вид физической активности, в котором используются определенная методика занятия и техника ходьбы при помощи специально разработанных палок.",
                imageUrl: "/Assets/Programs/7.jpg",
            },
            {
                title: "Ударно-волновая терапия",
                description: "Ударно-волновая терапия основана на воздействии, которое способны оказывать низкочастотные акустические волны на ткани человеческого тела.",
                imageUrl: "/Assets/Programs/8.jpg",
            },
        ]
    },
];